import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import Skeleton from '@mui/material/Skeleton';
import { UiCard } from 'ui-components';
import { StyledSearchLoading } from './SearchLoading.styles';

function SearchLoading({ type = 'content', count }) {
  const pageContentCountSlider = useSelector(
    (state) => state.settingsReducer.filters.public.pageContentCountSlider
  );

  return (
    <StyledSearchLoading>
      <div className={classNames('search-loading', type)}>
        {Array(count || pageContentCountSlider.selectedValue)
          .fill()
          .map((_, index) => (
            <UiCard key={index} className='card news-item'>
              <div
                component='CardHeader'
                className='header content-item-header news-item-header flex'
              >
                <div className='column'>
                  <Skeleton
                    variant='rounded'
                    animation='wave'
                    width={36}
                    height={36}
                    sx={{
                      marginRight: '8px',
                      marginLeft: '8px',
                      borderRadius: '6px',
                    }}
                  />
                  <Skeleton animation='wave' height={18} width='50%' />
                </div>
                <div className='column'>
                  {type === 'content' && (
                    <>
                      <Skeleton animation='wave' height={10} width='15%' />
                      <Skeleton
                        animation='wave'
                        height={10}
                        width='18%'
                        sx={{ marginLeft: '16px', marginRight: '16px' }}
                      />
                    </>
                  )}
                  {type === 'resource' && (
                    <Skeleton
                      animation='wave'
                      variant='rectangle'
                      height={24}
                      width='3%'
                      sx={{ marginLeft: '16px', marginRight: '16px' }}
                    />
                  )}
                </div>
              </div>
              {type === 'content' && (
                <>
                  <div
                    component='CardBody'
                    className='body content-item-body news-item-body'
                  >
                    <Skeleton
                      animation='wave'
                      height={10}
                      width='80%'
                      sx={{ marginBottom: '10px' }}
                    />
                    <Skeleton animation='wave' height={10} width='40%' />
                  </div>
                  <div
                    component='CardFooter'
                    className='footer content-item-footer news-item-footer flex'
                  ></div>
                </>
              )}
            </UiCard>
          ))}
      </div>
    </StyledSearchLoading>
  );
}

SearchLoading.propTypes = {
  type: PropTypes.oneOf(['content', 'resource']),
  count: PropTypes.number,
};

export default memo(SearchLoading);
